<template>
    <div class="provider-info">
        <div style="height:50px;line-height:50px;padding-left:15px;color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;background:#fff;">服务商信息</div>
        <div style="flex:1;overflow-y:auto;padding:16px 24px 24px 16px;display:flex;flex-direction:column">
            <div style="background:#fff;padding:20px 24px;position:relative;height:300px;box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04)">
                <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">
                    <span>基本信息</span>
                </div>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="item-title">服务商名称：</span>
                        <span class="item-content">{{basicInfo.name}}</span>
                    </a-col>
                    <a-col :span="12">
                        <span class="item-title">联系人：</span>
                        <span class="item-content">{{basicInfo.contactName}}</span>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="item-title">手机号：</span>
                        <span class="item-content">{{basicInfo.contactPhone}}</span>
                    </a-col>
                    <a-col :span="12">
                        <span class="item-title">邮箱：</span>
                        <span class="item-content">{{basicInfo.contactEmail}}</span>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="item-title">合作状态：</span>
                        <span class="item-content">{{basicInfo.cooperationStatus}}</span>
                    </a-col>
                    <a-col :span="12">
                        <span class="item-title">负责人：</span>
                        <span class="item-content">{{basicInfo.owner}}</span>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="item-title">地址：</span>
                        <span class="item-content" :title='basicInfo.address'>{{basicInfo.address.length>32?basicInfo.address.substr(0,32)+'...':basicInfo.address}}</span>
                    </a-col>
                    <a-col :span="12">
                        <span class="item-title">服务商标签：</span>
                        <span class="item-content" v-html="basicInfo.labelNames"></span>
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="item-title">创建时间：</span>
                        <span class="item-content">{{basicInfo.createTime}}</span>
                    </a-col>
                    <a-col :span="12">
                        <span class="item-title">合作截止日期：</span>
                        <span class="item-content">{{basicInfo.cooperationLimitTime}}</span>
                    </a-col>
                </a-row>
            </div>
            <div style="background:#fff;padding:20px 24px;position:relative;flex:1;box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04);margin:16px 0 0">
                <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">
                    <span>结算价信息</span>
                </div>
                <div style="margin-top:20px;">
                    <a-table bordered  
                        :data-source="basicInfo.settlementPriceList" 
                        :pagination='false' 
                        class="cloudy-table" 
                        :rowKey="(record,index)=>{return index}"
                    >
                        <a-table-column key="index" title="" data-index="index">
                            <template slot-scope="text, record, index">
                                <div>{{index}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="appName" title="所属应用" data-index="appName">
                            <template slot-scope="text, record">
                                <div>{{record.appName}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="commodityName" title="商品名称" data-index="commodityName">
                            <template slot-scope="text, record">
                                <div>{{record.commodityName}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="description" title="商品规格" data-index="description">
                            <template slot-scope="text, record">
                                <div>{{record.description}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="unitPrice" title="单价(元)" data-index="unitPrice">
                            <template slot-scope="text, record">
                                <div>{{record.unitPrice}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="settlementPrice" title="结算价" data-index="settlementPrice">
                            <template slot-scope="text, record">
                                <div>{{record.settlementPrice}}</div>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProviderInfo',
        data() {
            return {
                basicInfo: ''
            }   
        },
        methods: {
            queryBasicInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProvider', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.basicInfo = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
        },
        mounted: function() {
            this.queryBasicInfo()
        }
    }
</script>

<style scoped lang="less">
    .provider-info{
        height: 100%;
        display: flex;
        flex-direction: column;
        .row-list{
            margin-top: 24px;
            .item-title{
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                display:inline-block;
                width: 99px;
            }
            .item-content{
                color: rgba(18, 18, 18, 1);
                font-size: 13px;
            }
        }
    }
    
</style>